(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    let observer;
    let paymentObserver;
    const connectFooter = () => {
      if (observer) observer.disconnect();
      if (paymentObserver) paymentObserver.disconnect();
      document.documentElement.classList.remove('moebe-footer-in-view');
      const footer = document.querySelector('.site-footer');
      if (!footer) return;
      const moebeColumn = Array.from(footer.querySelectorAll('.grid__item[data-type="custom"]')).find(column => column.querySelector('.footer__title')?.textContent.trim().toLowerCase() === 'moebe');
      const text = moebeColumn?.querySelector('.footer__collapsible');
      const alignPayments = () => {
        if (!text || !moebeColumn.isConnected) return;
        const walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
        let node;
        let right = text.getBoundingClientRect().left;
        while ((node = walker.nextNode())) {
          if (!node.textContent.trim()) continue;
          const range = document.createRange();
          range.selectNodeContents(node);
          for (const rect of range.getClientRects()) {
            if (rect.width > 0) right = Math.max(right, rect.right);
          }
        }
        const inset = Math.max(0, moebeColumn.getBoundingClientRect().right - right);
        footer.style.setProperty('--footer-payment-text-inset', inset + 'px');
      };
      if (text) {
        paymentObserver = new ResizeObserver(alignPayments);
        paymentObserver.observe(text);
        alignPayments();
        document.fonts.ready.then(alignPayments);
      }
      observer = new IntersectionObserver((entries) => {
        document.documentElement.classList.toggle('moebe-footer-in-view', entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(footer);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', connectFooter, { once: true });
    } else {
      connectFooter();
    }
    document.addEventListener('shopify:section:load', connectFooter);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.querySelector('.site-footer')) {
        if (observer) observer.disconnect();
        document.documentElement.classList.remove('moebe-footer-in-view');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moebe-catalogue-viewer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moebe-catalogue-viewer')) {
    class MoebeCatalogueViewer extends HTMLElement {
      connectedCallback() {
        if (this.active || !this.dataset.pdfUrl) return;
        this.active = true;
        this.life = new AbortController();
        this.stage = this.querySelector('.moebe-catalogue__stage');
        this.book = this.querySelector('.moebe-catalogue__book');
        this.message = this.querySelector('.moebe-catalogue__message');
        this.toolbar = this.querySelector('.moebe-catalogue__toolbar');
        this.pageInput = this.querySelector('input[name="page"]');
        this.page = Math.max(1, Math.round(Number(this.dataset.startPage) || 1));
        this.half = 0;
        this.mobileLeaves = null;
        this.mobileIndexTask = null;
        this.pageSizes = new Map();
        this.mobileViewport = window.matchMedia('(max-width: 749px) and (orientation: portrait)');
        this.zoom = 1;
        this.sequence = (this.sequence || 0) + 1;
        this.generation = (this.generation || 0) + 1;
        this.tasks = new Set();
        this.textTasks = new Set();
        this.renderedNumbers = null;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.life.signal };
        this.mobileViewport.addEventListener('change', () => this.queueResize(), options);
        this.motionPreference.addEventListener('change', () => {
          if (this.motionPreference.matches) this.cancelTurn();
        }, options);
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-action]');
          if (button) this.action(button.dataset.action);
        }, options);
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          if (this.splitMobile()) this.goMobile(Number(this.pageInput.value) - 1);
          else this.go(Number(this.pageInput.value));
          this.pageInput.blur();
          this.stage.focus({ preventScroll: true });
        }, options);
        this.addEventListener('keydown', event => {
          if (!this.pdf || event.target.matches('input, textarea, select') || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
          const actions = { ArrowLeft: 'previous', ArrowRight: 'next', Home: 'first', End: 'last' };
          if (actions[event.key]) {
            event.preventDefault();
            this.action(actions[event.key]);
          }
        }, options);
        this.stage.addEventListener('touchstart', event => {
          this.touch = event.touches.length === 1 && this.zoom <= 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { ...options, passive: true });
        this.stage.addEventListener('touchend', event => {
          if (!this.touch || !event.changedTouches.length || event.touches.length) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.8 && !window.getSelection()?.toString()) this.action(dx < 0 ? 'next' : 'previous');
        }, { ...options, passive: true });
        this.stage.addEventListener('touchcancel', () => { this.touch = null; }, options);
        document.addEventListener('fullscreenchange', () => this.updateFullscreen(), options);
        this.resizer = new ResizeObserver(entries => {
          const { width, height } = entries[0].contentRect;
          const size = `${Math.round(width)}:${Math.round(height)}`;
          if (this.lastSize === size) return;
          this.lastSize = size;
          this.queueResize();
        });
        this.resizer.observe(this.stage);
        this.visibility = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.visibility.disconnect();
          this.load();
        }, { rootMargin: '300px' });
        this.visibility.observe(this);
      }

      queueResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          if (this.active && this.pdf) {
            if (this.splitMobile()) this.prepareMobileIndex();
            this.render();
          }
        }, 140);
      }

      disconnectedCallback() {
        this.active = false;
        this.generation++;
        this.sequence++;
        this.life?.abort();
        this.visibility?.disconnect();
        this.resizer?.disconnect();
        clearTimeout(this.resizeTimer);
        this.cancelTurn();
        this.cancelRendering();
        this.closeExpandedView();
        this.loadingTask?.destroy().catch(() => {});
        this.loadingTask = null;
        this.pdf = null;
        this.loading = false;
      }

      cancelRendering() {
        this.tasks?.forEach(task => task.cancel());
        this.textTasks?.forEach(task => task.cancel());
        this.tasks?.clear();
        this.textTasks?.clear();
      }

      cancelTurn() {
        this.turnAnimations?.forEach(animation => animation.cancel());
        this.turnAnimations = [];
        this.turnLayer?.remove();
        this.turnLayer = null;
        this.book?.removeAttribute('data-cover-turn');
        this.stage?.removeAttribute('data-turning');
      }

      updateFullscreen() {
        const expanded = document.fullscreenElement === this || Boolean(this.expandedDialog?.open);
        const label = expanded ? this.dataset.exitLabel : this.dataset.fullscreenLabel;
        const button = this.querySelector('[data-action="fullscreen"]');
        button.setAttribute('aria-label', label);
        button.title = label;
        button.setAttribute('aria-pressed', String(expanded));
        button.querySelector('[data-fullscreen-text]').textContent = label;
        button.querySelector('[data-expand-icon]').toggleAttribute('hidden', expanded);
        button.querySelector('[data-collapse-icon]').toggleAttribute('hidden', !expanded);
      }

      async toggleFullscreen() {
        if (this.expandedDialog) {
          this.closeExpandedView();
          return;
        }
        if (document.fullscreenElement === this) {
          await document.exitFullscreen().catch(() => {});
          return;
        }
        if (this.requestFullscreen && document.fullscreenEnabled) {
          try {
            await this.requestFullscreen();
            return;
          } catch {}
        }
        if (!this.active) return;
        const dialog = document.createElement('dialog');
        dialog.className = 'moebe-catalogue__fullscreen-dialog';
        dialog.setAttribute('aria-label', this.querySelector('.moebe-catalogue__reader').getAttribute('aria-label'));
        this.expandedDialog = dialog;
        this.beforeExpanded = { overflow: document.documentElement.style.overflow, minHeight: this.style.minHeight };
        this.style.minHeight = `${this.getBoundingClientRect().height}px`;
        document.documentElement.style.overflow = 'hidden';
        dialog.append(this.querySelector('.moebe-catalogue__header'), this.querySelector('.moebe-catalogue__reader'));
        this.append(dialog);
        dialog.addEventListener('close', () => {
          if (this.expandedDialog === dialog) this.closeExpandedView();
        }, { once: true });
        dialog.showModal();
        this.updateFullscreen();
        this.querySelector('[data-action="fullscreen"]').focus({ preventScroll: true });
      }

      closeExpandedView() {
        const dialog = this.expandedDialog;
        if (!dialog) return;
        this.expandedDialog = null;
        if (dialog.open) dialog.close();
        this.prepend(...dialog.children);
        dialog.remove();
        document.documentElement.style.overflow = this.beforeExpanded.overflow;
        this.style.minHeight = this.beforeExpanded.minHeight;
        this.updateFullscreen();
        if (this.active) this.querySelector('[data-action="fullscreen"]').focus({ preventScroll: true });
      }

      splitMobile() {
        return this.mobileViewport.matches && this.dataset.mobileLayout !== 'spread';
      }

      prepareMobileIndex() {
        if (this.mobileLeaves || this.mobileIndexTask || !this.pdf) return;
        const generation = this.generation;
        const pdf = this.pdf;
        let next = 1;
        const groups = new Array(pdf.numPages);
        const task = Promise.all(Array.from({ length: Math.min(4, pdf.numPages) }, async () => {
          while (next <= pdf.numPages && this.active && generation === this.generation) {
            const number = next++;
            const page = await pdf.getPage(number);
            const size = page.getViewport({ scale: 1 });
            if (!this.active || generation !== this.generation) return;
            this.pageSizes.set(number, size);
            groups[number - 1] = size.width > size.height * 1.1
              ? [{ page: number, half: 0 }, { page: number, half: 1 }]
              : [{ page: number, half: 0 }];
          }
        })).then(() => {
          if (!this.active || generation !== this.generation) return;
          this.mobileLeaves = groups.flat();
          this.updateControls(this.pages());
        }).catch(() => {
          if (this.active && generation === this.generation) {
            this.showMessage(this.dataset.error, true);
            this.stage.setAttribute('aria-busy', 'false');
          }
        }).finally(() => {
          if (this.mobileIndexTask === task) this.mobileIndexTask = null;
        });
        this.mobileIndexTask = task;
      }

      mobilePosition() {
        return Math.max(0, this.mobileLeaves?.findIndex(leaf => leaf.page === this.page && leaf.half === this.half) ?? 0);
      }

      goMobile(index) {
        if (!this.mobileLeaves || !Number.isFinite(index)) return;
        const leaf = this.mobileLeaves[Math.max(0, Math.min(this.mobileLeaves.length - 1, Math.round(index)))];
        this.go(leaf.page, leaf.half);
      }

      snapshotPage(side = 'full') {
        const rect = this.book.getBoundingClientRect();
        const width = side === 'full' ? rect.width : rect.width / 2;
        const canvas = document.createElement('canvas');
        const density = Math.min(window.devicePixelRatio || 1, 1.5);
        canvas.width = Math.max(1, Math.ceil(width * density));
        canvas.height = Math.max(1, Math.ceil(rect.height * density));
        const context = canvas.getContext('2d');
        context.scale(canvas.width / width, canvas.height / rect.height);
        for (const source of this.book.querySelectorAll('.moebe-catalogue__page > canvas')) {
          const pageRect = source.getBoundingClientRect();
          context.drawImage(source, pageRect.left - rect.left - (side === 'right' ? rect.width / 2 : 0), pageRect.top - rect.top, pageRect.width, pageRect.height);
        }
        return canvas;
      }

      playCoverTurn(cover, timing) {
        const rect = this.book.getBoundingClientRect();
        const width = cover.opening ? rect.width : cover.width;
        const height = cover.opening ? rect.height : cover.height;
        const coverWidth = cover.opening ? cover.width : rect.width;
        const coverHeight = cover.opening ? cover.height : rect.height;
        const perspective = Math.max(2200, width * 1.25);
        const movement = Array.from({ length: 25 }, (_, index) => {
          const offset = index / 24;
          const progress = cover.opening ? offset : 1 - offset;
          const scaleX = coverWidth * 2 / width * (1 - progress) + progress;
          const scaleY = coverHeight / height * (1 - progress) + progress;
          const angle = Math.PI * progress;
          const edge = width / 2 * Math.cos(angle) / (1 - width / 2 * Math.sin(angle) / perspective);
          const center = (Math.min(0, edge) + Math.max(width / 2, edge)) / 2;
          return { offset, transform: `translateX(${-center * scaleX}px) scale(${scaleX}, ${scaleY})` };
        });
        const layer = document.createElement('div');
        layer.className = 'moebe-catalogue__turn moebe-catalogue__turn--cover';
        layer.setAttribute('aria-hidden', 'true');
        layer.inert = true;
        Object.assign(layer.style, { width: `${width}px`, height: `${height}px`, left: `${(rect.width - width) / 2}px`, top: `${(rect.height - height) / 2}px`, perspective: `${perspective}px` });
        const stationary = cover.opening ? this.snapshotPage('right') : cover.right;
        stationary.style.left = '50%';
        const leaf = document.createElement('div');
        leaf.className = 'moebe-catalogue__leaf';
        leaf.style.left = '50%';
        leaf.style.transformOrigin = 'left center';
        leaf.append(cover.opening ? cover.front : this.snapshotPage(), cover.opening ? this.snapshotPage('left') : cover.left);
        layer.append(stationary, leaf);
        this.book.setAttribute('data-cover-turn', cover.opening ? 'opening' : 'closing');
        this.book.append(layer);
        this.turnLayer = layer;
        const animations = [
          layer.animate(movement, timing),
          leaf.animate([{ transform: cover.opening ? 'rotateY(0deg)' : 'rotateY(-180deg)' }, { transform: cover.opening ? 'rotateY(-180deg)' : 'rotateY(0deg)' }], timing)
        ];
        if (this.dataset.centerShadow === 'true') {
          const gutter = document.createElement('span');
          gutter.className = 'moebe-catalogue__cover-gutter';
          layer.append(gutter);
          animations.push(gutter.animate([{ opacity: cover.opening ? 0 : 1 }, { opacity: cover.opening ? 1 : 0 }], timing));
          for (let side = 0; side < 2; side++) {
            const shade = document.createElement('span');
            shade.className = 'moebe-catalogue__leaf-shade';
            leaf.append(shade);
            animations.push(shade.animate([{ opacity: 0 }, { opacity: .65, offset: .5 }, { opacity: 0 }], timing));
          }
        }
        return animations;
      }

      playTurn(direction, previous, cover) {
        this.stage.setAttribute('data-turning', '');
        let animations;
        const duration = Math.max(300, Math.min(1600, Number(this.dataset.turnDuration) || 800));
        const timing = { duration, easing: 'cubic-bezier(.45, 0, .55, 1)', fill: 'both' };
        if (cover) {
          animations = this.playCoverTurn(cover, timing);
        } else if (previous) {
          const forward = direction > 0;
          const layer = document.createElement('div');
          layer.className = 'moebe-catalogue__turn';
          layer.setAttribute('aria-hidden', 'true');
          layer.inert = true;
          const stationary = forward ? previous.left : previous.right;
          stationary.style.left = forward ? '0' : '50%';
          const leaf = document.createElement('div');
          leaf.className = 'moebe-catalogue__leaf';
          leaf.style.left = forward ? '50%' : '0';
          leaf.style.transformOrigin = forward ? 'left center' : 'right center';
          leaf.append(forward ? previous.right : previous.left, this.snapshotPage(forward ? 'left' : 'right'));
          layer.append(stationary, leaf);
          this.book.append(layer);
          this.turnLayer = layer;
          animations = [leaf.animate([
            { transform: 'rotateY(0deg)' },
            { transform: `rotateY(${forward ? -180 : 180}deg)` }
          ], timing)];
          if (this.dataset.centerShadow === 'true') {
            for (let side = 0; side < 2; side++) {
              const shade = document.createElement('span');
              shade.className = 'moebe-catalogue__leaf-shade';
              leaf.append(shade);
              animations.push(shade.animate([{ opacity: 0 }, { opacity: .65, offset: .5 }, { opacity: 0 }], timing));
            }
          }
        } else {
          animations = [this.book.animate([
            { opacity: .92, transform: `perspective(1800px) rotateY(${direction * 4}deg)` },
            { opacity: 1, transform: 'perspective(1800px) rotateY(0deg)' }
          ], { ...timing, easing: 'ease-out' })];
        }
        this.turnAnimations = animations;
        Promise.all(animations.map(animation => animation.finished)).then(() => {
          if (this.turnAnimations === animations) this.cancelTurn();
        }).catch(() => {});
      }

      async load() {
        if (this.loading || this.pdf) return;
        this.loading = true;
        const generation = ++this.generation;
        this.showMessage(this.dataset.loading);
        this.toolbar.hidden = true;
        this.stage.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(this.dataset.pdfUrl, location.href);
          if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Unsupported URL');
          const engineURL = new URL(this.dataset.engineUrl, location.href).href;
          this.engine = await import(engineURL);
          if (!this.active || generation !== this.generation) return;
          this.engine.GlobalWorkerOptions.workerSrc = new URL(this.dataset.workerUrl, location.href).href;
          const resources = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@6.4.299/';
          this.loadingTask = this.engine.getDocument({
            url: url.href,
            isEvalSupported: false,
            enableXfa: false,
            disableAutoFetch: true,
            disableStream: true,
            cMapUrl: `${resources}cmaps/`,
            cMapPacked: true,
            standardFontDataUrl: `${resources}standard_fonts/`,
            wasmUrl: `${resources}wasm/`,
            iccUrl: `${resources}iccs/`
          });
          this.loadingTask.onPassword = () => {
            if (generation !== this.generation) return;
            this.showMessage(this.dataset.password, true);
            this.stage.setAttribute('aria-busy', 'false');
            this.loadingTask.destroy().catch(() => {});
          };
          const pdf = await this.loadingTask.promise;
          if (!this.active || generation !== this.generation) return;
          this.pdf = pdf;
          const firstPage = await pdf.getPage(1);
          if (!this.active || generation !== this.generation) return;
          const firstSize = firstPage.getViewport({ scale: 1 });
          this.pageSizes.set(1, firstSize);
          // A spread-exported catalogue can still have a portrait front cover.
          const interiorPage = this.dataset.layout === 'auto' && pdf.numPages > 1
            ? await pdf.getPage(2) : firstPage;
          if (!this.active || generation !== this.generation) return;
          const interiorSize = interiorPage.getViewport({ scale: 1 });
          this.pageSizes.set(interiorPage.pageNumber, interiorSize);
          this.isLandscape = [firstSize, interiorSize].some(size => size.width > size.height * 1.1);
          this.page = Math.min(this.page, pdf.numPages);
          this.pageInput.max = String(pdf.numPages);
          this.querySelector('[data-total]').textContent = String(pdf.numPages);
          this.toolbar.hidden = false;
          if (this.splitMobile()) this.prepareMobileIndex();
          await this.render();
        } catch (error) {
          if (this.active && generation === this.generation) {
            this.pdf = null;
            this.toolbar.hidden = true;
            this.showMessage(error.name === 'PasswordException' ? this.dataset.password : this.dataset.error, true);
            this.stage.setAttribute('aria-busy', 'false');
            if (this.loadingTask) await this.loadingTask.destroy().catch(() => {});
            this.loadingTask = null;
          }
        } finally {
          if (generation === this.generation) this.loading = false;
        }
      }

      showMessage(text, retry = false) {
        this.querySelector('[data-message]').textContent = text;
        this.querySelector('[data-action="retry"]').hidden = !retry;
        this.message.hidden = false;
      }

      spread() {
        return this.dataset.layout !== 'single' && this.stage.clientWidth >= 750 && !this.isLandscape;
      }

      pages() {
        if (!this.spread() || (this.page === 1 && this.dataset.cover === 'true')) return [this.page];
        const first = this.dataset.cover === 'true' ? this.page - this.page % 2 : this.page - (this.page - 1) % 2;
        return [first, first + 1].filter(page => page > 0 && page <= this.pdf.numPages);
      }

      go(page, half = 0) {
        if (!this.pdf || !Number.isFinite(page)) return;
        this.page = Math.max(1, Math.min(this.pdf.numPages, Math.round(page)));
        this.half = half === 1 ? 1 : 0;
        this.stage.scrollTo(0, 0);
        this.render(true);
      }

      action(action) {
        if (action === 'fullscreen') {
          this.toggleFullscreen();
          return;
        }
        if (action === 'retry') {
          if (this.pdf) {
            if (this.splitMobile()) this.prepareMobileIndex();
            this.render();
          }
          else this.load();
          return;
        }
        if (!this.pdf) return;
        const pages = this.pages();
        if (this.splitMobile()) {
          if (action === 'previous') this.goMobile(this.mobilePosition() - 1);
          if (action === 'next') this.goMobile(this.mobilePosition() + 1);
          if (action === 'first') this.goMobile(0);
          if (action === 'last') this.goMobile((this.mobileLeaves?.length || 1) - 1);
        } else {
          if (action === 'previous') this.go(pages[0] - 1);
          if (action === 'next') this.go(pages[pages.length - 1] + 1);
          if (action === 'first') this.go(1);
          if (action === 'last') this.go(this.pdf.numPages);
        }
        if (['zoom-in', 'zoom-out', 'fit'].includes(action)) {
          this.zoom = action === 'fit' ? 1 : Math.max(.75, Math.min(3, this.zoom + (action === 'zoom-in' ? .25 : -.25)));
          this.render();
        }
      }

      updateControls(numbers) {
        const mobile = this.splitMobile();
        const indexing = mobile && !this.mobileLeaves;
        const total = mobile ? this.mobileLeaves?.length : this.pdf.numPages;
        const current = mobile ? this.mobilePosition() + 1 : this.page;
        this.pageInput.value = String(current);
        this.pageInput.max = String(total || 1);
        this.pageInput.disabled = indexing;
        this.querySelector('[data-total]').textContent = indexing ? '…' : String(total);
        this.querySelector('[data-action="previous"]').disabled = indexing || (mobile ? current === 1 : numbers[0] === 1);
        this.querySelector('[data-action="next"]').disabled = indexing || (mobile ? current === total : numbers[numbers.length - 1] === this.pdf.numPages);
        this.querySelector('[data-action="zoom-out"]').disabled = this.zoom <= .75;
        this.querySelector('[data-action="zoom-in"]').disabled = this.zoom >= 3;
        this.querySelector('[data-zoom]').textContent = `${Math.round(this.zoom * 100)}%`;
      }

      async render(transition = false) {
        if (!this.active || !this.pdf || !this.stage.clientWidth) return;
        const sequence = ++this.sequence;
        this.cancelTurn();
        this.cancelRendering();
        const numbers = this.pages();
        const mobile = this.splitMobile();
        const half = mobile ? this.half : 0;
        const position = numbers[0] + half / 2;
        const direction = this.renderedNumbers ? Math.sign(position - this.renderedPosition) : 0;
        const animate = transition && direction !== 0 && this.dataset.pageTurn === 'true' && !this.motionPreference.matches && this.zoom === 1;
        this.updateControls(numbers);
        this.stage.setAttribute('aria-busy', 'true');
        if (!this.renderedNumbers) this.showMessage(this.dataset.loading);
        else this.message.hidden = true;
        try {
          const pages = await Promise.all(numbers.map(number => this.pdf.getPage(number)));
          if (!this.active || sequence !== this.sequence) return;
          const css = getComputedStyle(this.stage);
          const width = Math.max(100, this.stage.clientWidth - parseFloat(css.paddingLeft) - parseFloat(css.paddingRight) - (numbers.length - 1) * 2);
          const height = Math.max(100, this.stage.clientHeight - parseFloat(css.paddingTop) - parseFloat(css.paddingBottom));
          const sizes = pages.map(page => page.getViewport({ scale: 1 }));
          pages.forEach((page, index) => this.pageSizes.set(page.pageNumber, sizes[index]));
          const crop = mobile && sizes[0].width > sizes[0].height * 1.1;
          const fit = Math.min(width / sizes.reduce((total, size) => total + size.width / (crop ? 2 : 1), 0), height / Math.max(...sizes.map(size => size.height)));
          const views = pages.map(page => page.getViewport({ scale: fit * this.zoom }));
          const fragment = document.createDocumentFragment();
          const jobs = pages.map((page, index) => {
            const view = views[index];
            const container = document.createElement('article');
            container.className = 'moebe-catalogue__page';
            container.dataset.page = String(numbers[index]);
            container.dataset.half = crop ? (half ? 'right' : 'left') : 'none';
            const labelNumber = mobile && this.mobileLeaves ? this.mobilePosition() + 1 : numbers[index];
            container.setAttribute('aria-label', `${this.dataset.pageLabel} ${labelNumber}`);
            const visibleWidth = view.width / (crop ? 2 : 1);
            const cropX = crop && half ? visibleWidth : 0;
            container.style.width = `${visibleWidth}px`;
            container.style.height = `${view.height}px`;
            container.style.setProperty('--scale-factor', String(view.scale));
            container.style.setProperty('--total-scale-factor', String(view.scale));
            const canvas = document.createElement('canvas');
            const density = Math.max(.5, Math.min(window.devicePixelRatio || 1, 2, Math.sqrt(6000000 / (visibleWidth * view.height))));
            canvas.width = Math.ceil(visibleWidth * density);
            canvas.height = Math.ceil(view.height * density);
            canvas.style.width = `${visibleWidth}px`;
            canvas.style.height = `${view.height}px`;
            canvas.setAttribute('aria-hidden', 'true');
            container.append(canvas);
            fragment.append(container);
            return { page, view, canvas, density, container, cropX, visibleWidth, crop };
          });
          await Promise.all(jobs.map(async job => {
            const task = job.page.render({
              canvasContext: job.canvas.getContext('2d'),
              viewport: job.view,
              transform: [job.density, 0, 0, job.density, -job.cropX * job.density, 0]
            });
            this.tasks.add(task);
            try { await task.promise; } finally { this.tasks.delete(task); }
          }));
          if (!this.active || sequence !== this.sequence) return;
          const oldRect = this.book.getBoundingClientRect();
          const newWidth = jobs.reduce((sum, job) => sum + job.visibleWidth, 0) + (views.length - 1) * 2;
          const newHeight = Math.max(...views.map(view => view.height));
          const gutter = !crop && (numbers.length === 2 || sizes[0].width > sizes[0].height * 1.1);
          const matchingSpread = animate && gutter && this.book.dataset.gutter === 'true' && Math.abs(oldRect.width - newWidth) < 2 && Math.abs(oldRect.height - newHeight) < 2;
          const previous = matchingSpread ? { left: this.snapshotPage('left'), right: this.snapshotPage('right') } : null;
          const openingCover = animate && !mobile && this.renderedNumbers?.length === 1 && this.renderedNumbers[0] === 1 && this.book.dataset.gutter !== 'true' && numbers[0] === 2 && gutter;
          const closingCover = animate && !mobile && this.renderedNumbers?.[0] === 2 && this.book.dataset.gutter === 'true' && numbers.length === 1 && numbers[0] === 1 && !gutter;
          const cover = openingCover ? { opening: true, width: oldRect.width, height: oldRect.height, front: this.snapshotPage() } : closingCover ? { opening: false, width: oldRect.width, height: oldRect.height, left: this.snapshotPage('left'), right: this.snapshotPage('right') } : null;
          this.book.replaceChildren(fragment);
          this.book.dataset.gutter = String(gutter);
          this.renderedNumbers = numbers;
          this.renderedPosition = position;
          if (animate) this.playTurn(direction, previous, cover);
          this.message.hidden = true;
          this.stage.setAttribute('aria-busy', 'false');
          this.querySelector('[data-announcement]').textContent = `${this.dataset.pageLabel} ${mobile && this.mobileLeaves ? this.mobilePosition() + 1 : numbers.join('–')} ${this.dataset.ofLabel} ${mobile && this.mobileLeaves ? this.mobileLeaves.length : this.pdf.numPages}`;
          await Promise.allSettled(jobs.map(job => this.addTextAndLinks(job, sequence)));
        } catch (error) {
          if (sequence !== this.sequence || !this.active || error.name === 'RenderingCancelledException') return;
          this.cancelTurn();
          this.showMessage(this.dataset.error, true);
          this.stage.setAttribute('aria-busy', 'false');
        }
      }

      async addTextAndLinks({ page, view, container, cropX, visibleWidth, crop }, sequence) {
        const [content, annotations] = await Promise.all([page.getTextContent(), page.getAnnotations({ intent: 'display' })]);
        if (!this.active || sequence !== this.sequence) return;
        const text = document.createElement('div');
        text.className = 'moebe-catalogue__text';
        text.style.width = `${view.width}px`;
        text.style.transform = `translateX(${-cropX}px)`;
        container.append(text);
        const layer = new this.engine.TextLayer({ textContentSource: content, container: text, viewport: view });
        this.textTasks.add(layer);
        try { await layer.render(); } catch {
          text.className = 'moebe-catalogue__sr';
          text.textContent = content.items.map(item => item.str || '').join(' ');
        } finally { this.textTasks.delete(layer); }
        if (!this.active || sequence !== this.sequence) return;
        if (crop) {
          const bounds = container.getBoundingClientRect();
          for (const span of text.querySelectorAll('span')) {
            const rect = span.getBoundingClientRect();
            if (rect.right <= bounds.left || rect.left >= bounds.right) {
              span.setAttribute('aria-hidden', 'true');
              span.style.userSelect = 'none';
            }
          }
        }
        for (const annotation of annotations) {
          if (annotation.subtype !== 'Link' || !annotation.rect) continue;
          const rect = [...view.convertToViewportPoint(annotation.rect[0], annotation.rect[1]), ...view.convertToViewportPoint(annotation.rect[2], annotation.rect[3])];
          const link = document.createElement('a');
          link.className = 'moebe-catalogue__link';
          const left = Math.max(0, Math.min(rect[0], rect[2]) - cropX);
          const right = Math.min(visibleWidth, Math.max(rect[0], rect[2]) - cropX);
          if (right <= left) continue;
          link.style.left = `${left}px`;
          link.style.top = `${Math.min(rect[1], rect[3])}px`;
          link.style.width = `${right - left}px`;
          link.style.height = `${Math.abs(rect[3] - rect[1])}px`;
          if (annotation.url) {
            let url;
            try { url = new URL(annotation.url, location.href); } catch { continue; }
            if (!['https:', 'http:', 'mailto:', 'tel:'].includes(url.protocol)) continue;
            link.href = url.href;
            link.target = '_blank';
            link.rel = 'noopener';
            link.setAttribute('aria-label', `${this.dataset.linkLabel}: ${url.hostname || url.href}`);
          } else if (annotation.dest) {
            link.href = `#${this.id}`;
            link.setAttribute('aria-label', this.dataset.linkLabel);
            link.addEventListener('click', async event => {
              event.preventDefault();
              try {
                const destination = typeof annotation.dest === 'string' ? await this.pdf.getDestination(annotation.dest) : annotation.dest;
                if (!destination) return;
                const index = typeof destination[0] === 'number' ? destination[0] : await this.pdf.getPageIndex(destination[0]);
                this.go(index + 1);
              } catch {}
            }, { signal: this.life.signal });
          } else continue;
          container.append(link);
        }
      }
    }
    customElements.define('moebe-catalogue-viewer', MoebeCatalogueViewer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moebe-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('moebe-story-viewer')){
 customElements.define('moebe-story-viewer',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;
   this.ready=true;
   this.frames=JSON.parse(this.querySelector('script').textContent).map(s=>s.trim()).filter(Boolean);
   this.picture=this.querySelector('img');this.index=0;
   const preload=()=>{if(this.loaded)return;this.loaded=true;this.frames.forEach(src=>{const i=new Image();i.src=src;});};
   this.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{preload();this.show(this.index+Number(b.dataset.direction));}));
   this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();preload();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
   this.addEventListener('pointerdown',e=>{if(e.target.closest('button'))return;preload();this.start=e.clientX;this.pointer=e.pointerId;this.setPointerCapture(e.pointerId);});
   this.addEventListener('pointermove',e=>{if(this.pointer!==e.pointerId)return;const delta=e.clientX-this.start;if(Math.abs(delta)>7){this.show(this.index+(delta>0?-1:1));this.start=e.clientX;}});
   const end=()=>{this.pointer=null;};this.addEventListener('pointerup',end);this.addEventListener('pointercancel',end);
  }
  show(index){this.index=(index+this.frames.length)%this.frames.length;this.picture.src=this.frames[this.index];}
 });
}

function initMoebeStoryAutoplay(root){
 root.querySelectorAll('video[data-story-autoplay]').forEach(video=>{
  if(video.dataset.autoplayReady)return;
  video.dataset.autoplayReady='true';
  video.muted=true;
  const observer=new IntersectionObserver(entries=>{
   entries.forEach(entry=>{
    if(entry.isIntersecting){video.play().catch(()=>{});}
    else{video.pause();}
   });
  },{threshold:0.15});
  observer.observe(video);
 });
}
if(document.readyState==='loading'){
 document.addEventListener('DOMContentLoaded',()=>initMoebeStoryAutoplay(document),{once:true});
}else{initMoebeStoryAutoplay(document);}
document.addEventListener('shopify:section:load',event=>initMoebeStoryAutoplay(event.target));

  } catch(e) { console.error(e); }
})();
})();
